import React from "react";
import { SortDirectionType } from "react-virtualized";

export const useSort = ({
  sortBy,
  sortDirection,
}: {
  sortBy?: string | undefined;
  sortDirection?: SortDirectionType | undefined;
} = {}) => {
  const [sort, setSort] = React.useState<string | undefined>(sortBy);
  const [direction, setDirection] = React.useState<
    SortDirectionType | undefined
  >(sortDirection);

  const onSort = ({
    sortBy,
    sortDirection,
  }: {
    sortBy: string;
    sortDirection: SortDirectionType;
  }) => {
    setSort(sortBy);
    setDirection(sortDirection);
  };

  return { sort, direction, onSort };
};
